import React from "react";
import "./PortalAlert.css";

type Tone = "info" | "success" | "warn" | "danger";

type Props = {
  tone?: Tone;
  title?: string;
  children?: React.ReactNode;
  /** Renders only an icon + title inline (no title/body split). */
  compact?: boolean;
};

function Icon({ tone }: { tone: Tone }) {
  if (tone === "success") {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M20 6 9 17l-5-5" />
      </svg>
    );
  }
  if (tone === "warn") {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
    );
  }
  if (tone === "danger") {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
    );
  }
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  );
}

export default function PortalAlert({
  tone = "info",
  title,
  children,
  compact = false,
}: Props) {
  const role = tone === "danger" || tone === "warn" ? "alert" : "status";
  return (
    <div className={`pa-alert pa-alert--${tone}`} role={role}>
      <div className="pa-alert-icon" aria-hidden="true">
        <Icon tone={tone} />
      </div>
      <div className="pa-alert-body">
        {title ? <div className="pa-alert-title">{title}</div> : null}
        {children && !compact ? (
          <div className="pa-alert-text">{children}</div>
        ) : null}
        {children && compact && !title ? (
          <div className="pa-alert-title">{children}</div>
        ) : null}
      </div>
    </div>
  );
}
